export function formatDisplayUrl(raw?: string | null): string {
  if (!raw) return ''
  try {
    const base =
      raw.startsWith('http') || raw.startsWith('data:')
        ? undefined
        : typeof window !== 'undefined'
          ? window.location.origin
          : 'https://insightatlas.ai'
    const url = new URL(raw, base)
    const host = url.hostname.replace(/^www\./, '')
    let path = url.pathname
    if (path === '/') path = ''
    if (path.length > 48) {
      path = `${path.slice(0, 45)}…`
    }
    const search = url.search && url.search.length < 12 ? url.search : ''
    return `${host}${path}${search}`
  } catch {
    return raw.replace(/^https?:\/\//, '')
  }
}

export function resolveAssetUrl(raw?: string | null, baseUrl?: string): string | undefined {
  if (!raw) return undefined
  if (/^data:/.test(raw)) return raw
  if (/^https?:\/\//i.test(raw)) return raw
  const normalizedBase = (baseUrl || '').replace(/\/$/, '')
  const normalizedPath = raw.startsWith('/') ? raw : `/${raw}`
  return `${normalizedBase}${normalizedPath}`
}

const INTERNAL_URL_BASE = 'https://insightatlas.local'

function isResearchBinaryPath(pathname: string): boolean {
  return /^\/images\/(?:research_[^/]+|intelligence_[^/]+)\.png$/i.test(pathname)
}

export function resolveResearchCardImageUrl(raw?: string | null, baseUrl?: string): string | undefined {
  if (!raw) return undefined
  if (/^data:/i.test(raw)) return raw

  const isAbsolute = /^https?:\/\//i.test(raw)
  const url = new URL(raw, isAbsolute ? undefined : INTERNAL_URL_BASE)

  const legacyResearchMatch = url.pathname.match(/^\/research\/(\d+)\/image$/i)
  const legacyIntelligenceMatch = url.pathname.match(/^\/(?:api\/)?intelligence\/report\/([^/]+)\/image$/i)

  if (legacyResearchMatch) {
    url.pathname = `/images/research_${legacyResearchMatch[1]}.png`
  } else if (legacyIntelligenceMatch) {
    url.pathname = `/images/intelligence_${legacyIntelligenceMatch[1]}.png`
  }

  if (isResearchBinaryPath(url.pathname) && !url.searchParams.has('variant')) {
    url.searchParams.set('variant', 'card')
  }

  const resolved = isAbsolute ? url.toString() : `${url.pathname}${url.search}${url.hash}`
  return resolveAssetUrl(resolved, baseUrl)
}


